// extracted by mini-css-extract-plugin
module.exports = {"profileWrapper":"d_j","avatar":"d_k","socialHeading":"d_l"};